import PropTypes from 'prop-types'
import React from 'react'
import { withI18next } from 'lib/i18n/withI18next'
import useMobileGallery from './useMobileGallery'
import LegacyProductCarouselImages from './LegacyProductCarouselImages'
import ProductGallery from './gallery/ProductGallery'
import { galleryMedia } from './gallery/media'

const ProductCarouselImages = ({ images, video, isPhone, phone, ...props }) => {
  const isMobileGallery = useMobileGallery(isPhone, phone)
  // Desktop and app webviews always retain their existing gallery.
  // Mobile web requires an explicit A assignment; all other values fall back.
  if (!isMobileGallery) {
    return (
      <LegacyProductCarouselImages
        {...props}
        images={images}
        video={video}
        isPhone={isPhone}
        phone={phone}
      />
    )
  }
  const media = galleryMedia(images, video)
  if (!media.length) return null
  // Reset selection and close the viewer when the product or media changes.
  const identity = `${props.id}:${media
    .map((item) => `${item.poster}:${item.src}`)
    .join('|')}`
  return (
    <ProductGallery
      key={identity}
      {...props}
      media={media}
      mobile={isPhone || phone}
    />
  )
}
ProductCarouselImages.defaultProps = {
  images: [],
  video: {},
  isPhone: false,
  phone: false,
  language: 'en',
}
ProductCarouselImages.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({ path: PropTypes.string, full_path: PropTypes.string }),
  ),
  video: PropTypes.shape({
    video_path: PropTypes.string,
    cover_image_path: PropTypes.string,
  }),
  isPhone: PropTypes.bool,
  phone: PropTypes.bool,
  language: PropTypes.string,
}
export default withI18next(['global'])(ProductCarouselImages)
